import Panel from 'Components/Panel';
import { actions as logActions } from 'ducks/logs';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import Table from './Table';

const Component = props => {
    const { device } = props;

    const [realtime, setRealtime] = React.useState(true);

    const dispatch = useDispatch();

    // the effect is the only thing that starts and stops the polling: the toggle just moves
    // the state and the effect reacts, instead of both dispatching in parallel
    useEffect(() => {
        if (!realtime) {
            return undefined;
        }

        dispatch(logActions.startPoolingRealtimeData(device.id));

        return () => dispatch(logActions.stopPoolingRealtimeData(device.id));
    }, [device.id, dispatch, realtime]);

    return (
        <React.Fragment>
            <Panel realtime={realtime} setRealtime={setRealtime}>
                <Table device={device} realtime={realtime}/>
            </Panel>
        </React.Fragment>
    );
};

export default Component;
